import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { BaseBasicDialog, IManagementRequest } from '@appshared';

@Component({
    selector: 'app-cancel-approved-request',
    templateUrl: './cancel-approved-request.component.html',
    styleUrls: ['./cancel-approved-request.component.scss'],
})
export class CancelApprovedRequestComponent extends BaseBasicDialog {
    reason: string;
    data: IManagementRequest;

    constructor(
        public dialogRef: MatDialogRef<CancelApprovedRequestComponent>,
        protected _fuseTranslationLoaderService: FuseTranslationLoaderService,
        protected _fuseProgressBarService: FuseProgressBarService
    ) {
        super(dialogRef, _fuseTranslationLoaderService, _fuseProgressBarService);
    }
}